import React from 'react';
import Images from 'images';
import { railIcons } from '../config/navIcons';
import {
  Rail,
  RailLogoWrap,
  RailLogoBox,
  RailLogo,
  RailLogoDivider,
  RailSection,
  RailItem,
  RailIcon,
  RailLabel,
  RailAvatar,
} from '../styled/IconRail.styled';

const platform = process.env.REACT_APP_PLATFORM;

const getRailLogo = () => {
  if (platform === 'tickethoss') return Images.hossHeadRail;
  if (platform === 'kartpass') return Images.logoKart;
  return Images.pitpayCollapsedLogo;
};

const IconRail = ({
  sections,
  activeSection,
  panelOpen,
  onRailClick,
  onThemeToggle,
  onSettingsClick,
  onPermissionDenied,
  user,
}) => {
  const initials = user
    ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`
    : '';

  return (
    <Rail>
      <RailLogoWrap>
        <RailLogoBox>
          <RailLogo src={getRailLogo()} alt={platform} />
        </RailLogoBox>
      </RailLogoWrap>
      <RailLogoDivider style={{ marginTop: 2 }} />

      <RailSection>
        {sections.map((section) => {
          const isActive = activeSection === section.id;
          const showArrow = isActive && panelOpen && section.type === 'section';
          const iconSvg = railIcons[section.id];

          const handleClick = () => {
            if (section.shown === false) {
              onPermissionDenied();
              return;
            }
            onRailClick(section);
          };

          return (
            <RailItem
              key={section.id}
              isActive={isActive}
              showArrow={showArrow}
              onClick={handleClick}
              title={section.label}
            >
              <RailIcon viewBox="0 0 24 24">{iconSvg}</RailIcon>
              <RailLabel className="rail-label" isActive={isActive}>
                {section.label}
              </RailLabel>
            </RailItem>
          );
        })}
        <RailItem
          isActive={false}
          showArrow={false}
          onClick={onThemeToggle}
          title="Toggle Theme"
        >
          <RailIcon viewBox="0 0 24 24">{railIcons.theme}</RailIcon>
          <RailLabel className="rail-label" isActive={false}>
            Light
          </RailLabel>
        </RailItem>
      </RailSection>

      <RailAvatar onClick={onSettingsClick} title={initials}>
        {initials}
      </RailAvatar>
    </Rail>
  );
};

export default IconRail;
